const vtConfig = [
  {
    id: '21318169096',
    name: 'PL Widgets Rate Table Link CTA to Landing Page',
    isManualTriggering: false,
    isRunning: true,
    isMobile: true,
    isDesktop: true,
    isTablet: true,
    allowOrganicTraffic: true,
    allowNonOrganicTraffic: true,
    urlConditions: [
      {
        url: 'personal-loan/rate-table.*theme=fox.*?',
        type: 'regexp',
      },
    ],
    variations: [
      {
        id: 0,
        description: 'V0 PL Widget CTA PL PQ form',
        isPaused: false,
        weight: 0.5,
      },
      {
        id: 1,
        description: 'V1 PL Widget CTA PL Landing Page',
        isPaused: false,
        weight: 0.5,
      },
    ],
    gaCustomDimension: 100,
  },
]

export default vtConfig
